import React from 'react'
import { CButton, CCard, CCardBody, CCardGroup, CCol, CForm, CRow } from '@coreui/react'
import { useMsal, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react'
import { loginRequest } from '../../config/MsalConfig'
import { Navigate } from 'react-router-dom'

//import DefaultLayout from '../../layout/DefaultLayout'

const Login = () => {
  const { instance } = useMsal()

  const handleLogin = (loginType) => {
    // Store the current URL to redirect back after login
    const currentUrl = window.location.hash || '#/'
    sessionStorage.setItem('preAuthUrl', currentUrl)

    const loginRequestWithUrl = {
      ...loginRequest,
      redirectUri: window.location.origin,
      state: currentUrl,
    }

    if (loginType === 'popup') {
      instance.loginPopup(loginRequestWithUrl)
    } else if (loginType === 'redirect') {
      instance.loginRedirect(loginRequestWithUrl)
    }
  }

  return (
    <div data-testid="logged">
      <AuthenticatedTemplate>
        <Navigate to="/imt" replace />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <div
          data-testid="notLogged"
          className="min-vh-100 d-flex flex-row align-items-center justify-content-center background"
        >
          <CCardGroup>
            <CCard className="text-white bg-login">
              <CCardBody className="text-center">
                <CCardBody>
                  <CForm className="pt-3">
                    <h1 style={{ color: '#000000' }}>Integration Monitoring Dashboard</h1>
                    <p style={{ color: '#000000' }}>
                      Authenticate your account by logging into H & M Hennes & Mauritz GBC AB’s
                      single sign-on (SSO) provider.
                    </p>
                    <CRow>
                      <CCol xs={12}>
                        <CButton
                          className="px-4 btn-login-button"
                          onClick={() => handleLogin('redirect')}
                          key="loginPopup"
                          data-testid="signInButton"
                        >
                          Sign In
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </div>
      </UnauthenticatedTemplate>
    </div>
  )
}

export default Login
